module.exports = __webpack_public_path__ + "img/JINMAO-icon.c9acea4f.png";